import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {SearchMethod} from "../types/SearchMethod";

interface TrackAmplitudeGlobalSearchParams {
    searchQuery: string;
    searchMethod: SearchMethod;
    searchContext: string;
    offersCount?: number;
    itemListId?: string;
}

let _lastSearchMethod: SearchMethod = "manual_input";
let _pendingGlobalSearch: (() => void) | null = null;

export const setPendingGlobalSearch = (fn: () => void): void => {
    _pendingGlobalSearch = fn;
};

export const firePendingGlobalSearch = (): boolean => {
    if (!_pendingGlobalSearch) {
        return false;
    }
    _pendingGlobalSearch();
    _pendingGlobalSearch = null;

    return true;
};

export const clearPendingGlobalSearch = (): void => {
    _pendingGlobalSearch = null;
};

export const getLastGlobalSearchMethod = (): SearchMethod => _lastSearchMethod;

export const trackAmplitudeGlobalSearch = (params: TrackAmplitudeGlobalSearchParams): void => {
    _lastSearchMethod = params.searchMethod;
    trackAmplitudeEvent("global_search", {
        search_query: params.searchQuery,
        search_method: params.searchMethod,
        search_context: params.searchContext,
        ...(params.offersCount !== undefined && {offers: params.offersCount}),
        ...(params.itemListId !== undefined && {item_list_id: params.itemListId})
    });
};
import {trackAmplitudeEvent} from "@pg-mono/amplitude";

import {SearchMethod} from "../types/SearchMethod";

interface TrackAmplitudeGlobalSearchParams {
    searchQuery: string;
    searchMethod: SearchMethod;
    searchContext: string;
    offersCount?: number;
    itemListId?: string;
}

let _lastSearchMethod: SearchMethod = "manual_input";
let _pendingGlobalSearch: (() => void) | null = null;

export const setPendingGlobalSearch = (fn: () => void): void => {
    _pendingGlobalSearch = fn;
};

export const firePendingGlobalSearch = (): boolean => {
    if (!_pendingGlobalSearch) {
        return false;
    }
    _pendingGlobalSearch();
    _pendingGlobalSearch = null;

    return true;
};

export const clearPendingGlobalSearch = (): void => {
    _pendingGlobalSearch = null;
};

export const getLastGlobalSearchMethod = (): SearchMethod => _lastSearchMethod;

export const trackAmplitudeGlobalSearch = (params: TrackAmplitudeGlobalSearchParams): void => {
    _lastSearchMethod = params.searchMethod;
    trackAmplitudeEvent("global_search", {
        search_query: params.searchQuery,
        search_method: params.searchMethod,
        search_context: params.searchContext,
        ...(params.offersCount !== undefined && {offers: params.offersCount}),
        ...(params.itemListId !== undefined && {item_list_id: params.itemListId})
    });
};
